export default {
    namespaced: true,
    state: {
        fnCallFlag: null,
        v1: null,
        v2: null,
        v3: null,
    },
    getters: {
        getV1(state) {
            return state.v1;
        },
        getV2(state) {
            return state.v2;
        },
        getV3(state) {
            return state.v3;
        }
    },
    mutations: {
        setFnCallFlag(state, event) {
            state.fnCallFlag = event;
        },
        setV1(state, v1) {
            state.v1 = v1;
        },
        setV2(state, v2) {
            state.v2 = v2;
        },
        setV3(state, v3) {
            state.v3 = v3;
        }
    },
    actions: {}
}